import {writable} from "../../_snowpack/pkg/svelte/store.js";
import addOrUpdateExpression from "../services/addOrUpdateExpression.js";
import deleteExpression from "../services/deleteExpression.js";
import {persistToLocalStorage, getFromLocalStorage} from "../services/localStoragePersistence.js";
const WORKSPACE_KEY = "workspace";
;
function createExpressionStore() {
  const getEmptyStore = () => new Map();
  const {set, subscribe, update} = writable(getFromLocalStorage(WORKSPACE_KEY));
  return {
    subscribe,
    addOrUpdate: (expression) => update((currentWorkspace) => addOrUpdateExpression(expression, currentWorkspace)),
    remove: (expression) => update((currentWorkspace) => deleteExpression(expression, currentWorkspace)),
    reset: () => set(getEmptyStore())
  };
}
function createUserStore() {
  const initialValue = {
    thousandSeparator: ".",
    decimalSeparator: ",",
    locale: "pt"
  };
  return writable(initialValue);
}
export const expressionStore = createExpressionStore();
export const userStore = createUserStore();
expressionStore.subscribe((store) => persistToLocalStorage(store, WORKSPACE_KEY));
